//SHARED FILE : USED ON DETAILS AND PRODUCT LIST
//ANY CHANGES SHOULD BE TESTED ON BOTH PAGES
$(function () {
	//omniture logging
	$('.viewProduct').on("click", function(e){
		e.preventDefault();
		omniture().ViewProductClick();
		window.location = e.currentTarget.href;
	});
	$('.viewProduct').on("keypress", function(e){ if (e.which == 13) { $(this).click(); } }); 
	//end omniture logging
   
	//idea board
	$('.faveLink').on('click touch', function (e) {
		e.preventDefault();
    		$(this).parent('.faveLinkWrapper').find('.ideaBoardList').slideDown('fast');
    		$(".cancelBoardList").focus();
	});
	$('.faveLink').on('keypress', function (e) { if (e.which == 13) { $(this).click(); } });
  
  	if ((!$('.favPrintIcons').hasClass('mobileList') && $('.favPrintIcons')[0]) || $('.favPrintIcons').hasClass('mobileDetails')) {
		var productID = (typeof (prodID) == 'undefined') ? $('#productid').val() : prodID;
		var data = { productID: productID };
		$.ajax({
			url: "/Product/IsItemInBoardAsync",
			contentType: "application/json",
			dataType: "json",
			type: "POST",
			data: JSON.stringify(data),
			success: function (result) {
				if (result.success == true)
					$('.favoriteItem').removeClass("textDkGray").addClass("textRed");
				else
					$('.favoriteItem').removeClass("textRed").addClass("textDkGray");
			},
			error: function (result) { }
		});
	}
	else {
		$('.faveLinkProdID').each(function (e, g) {
			var productID = $(this).val();
			var data = { productID: productID };
			$.ajax({
				url: "/Product/IsItemInBoardAsync",
				contentType: "application/json",
				dataType: "json",
				type: "POST",
				data: JSON.stringify(data),
				success: function (result) {
					if (result.success == true)
						$(g).parent().find('.faveLink').removeClass("textDkGray").addClass("textRed");
					else
						$(g).parent().find('.faveLink').removeClass("textRed").addClass("textDkGray");
					},
				error: function (result) { }
			});
		});
	}
    
	$('body').on('click', '.cancelBoardList', function (e) {
		e.preventDefault();
		$(this).parent('.ideaBoardList').slideUp('fast').prev(".faveLink").focus();
		$('.addToBoardMsg').each(function () {
			$(this).remove();
		});
	});
	$('body').on('keypress', '.cancelBoardList', function (e) { if (e.which == 13) { $(this).click(); } });
	  
	$('body').on('click', '.boardName', function (e) {
		e.preventDefault();
		$('.addToBoardMsg').remove();
		AddToIdeaBoard(this);
	});
	$('body').on('keypress', '.boardName', function (e) { if (e.which == 13) { $(this).click(); } });
	  
	$('.saveAsFavBoard').on('click', function (e) {
		e.preventDefault();
		$('.cancel-new-board').click();
		$('.newBoardMsg').remove();
		if ($(this).hasClass('registered')) {
			GetBoardForm();
		}
	});
	$('.saveAsFavBoard').on('keypress', function (e) { if (e.which == 13) { $(this).click(); } });
	  
	$('body').on('click', '.cancel-delete-item', function (e) {
		e.preventDefault();
		$(this).closest('.addToBoardMsg').slideUp('fast').remove();
	});
	$('body').on('keypress', ' .cancel-delete-item', function (e) { if (e.which == 13) { $(this).click(); } });
	  
	//add cart items to existing board	
	$('body').on('click', '.boardListItem', function (e) {
		e.preventDefault();
		$('.addToBoardMsg').remove();
		AddCartItemsToBoard(this);
	});
	$('body').on('keypress', ' .boardListItem', function (e) { if (e.which == 13) { $(this).click(); } });
	  
	$('body').on('click', '.confirm-delete-item', function (e) {
		e.preventDefault();
		var arr = $(this).attr('href').split('/');
		DeleteBoardItem(arr[0], arr[1], this);
	});
	$('body').on('keypress', '.confirm-delete-item', function (e) { if (e.which == 13) { $(this).click(); } });
	  
	$('body').on('click', '.cancelCartBoard', function (e) {
		e.preventDefault();
		$('#newBoardForm').remove();
		$('.saveAsFavBoard').focus();
	});
	  
	$('body').on('click', '.cancel-new-board', function () {
		var form = $(this).closest('#newBoardForm');
		form.addClass('slideLeft');
		form.find('.ErrorMsgPanel').slideUp('slow');
		form.find('#BoardName').removeAttr('style');
		setTimeout(function () {
			form.remove();
		}, 250);
		$('.create-board').attr('aria-expanded', 'false').focus();
		$('.saveAsFavBoard').focus();
	});
	$('body').on('keypress', '.cancel-new-board', function (e) { ClickOnKeyPress(this, e); });
	  
	$('body').on('click', '#submitNewBoard', function () {
		var form = $(this).closest('#newBoardForm');
		form.find('.ErrorMsgPanel').remove();
		var boardName = form.find('#BoardName');
		if (boardName.val() == '') {
			boardName.css('background-color', 'rgb(255, 217, 217)');
			var temp = GetValidationTemplate();
			temp = temp.replace('##ERRORLIST##', '<li class="boardNameError"><a href="#" tabindex="0" role="link"><span>Please enter a Board Name</span></a><li/>');
			form.find('.newBoardHdr').before(temp);
			form.find('#ErrorMsgBox li:last-child').remove();
			boardName.focus();
			return false;
		}
		CreateBoardWithCart(this);
	});
	$('body').on('keypress', '#submitNewBoard', function (e) { ClickOnKeyPress(this, e); });
	  
	//remove error messages
	$('body').on('keyup', 'input.boardName', function () {
		if (this.value != '') {
			var form = $(this).closest('#newBoardForm');
			if (form.length == 0) {
				form = $(this).closest('#editBoardForm');
				if (form.length == 0) {
					form = $(this).closest('#sharingPanel');
				}
			}
			form.find('.ErrorMsgPanel').slideUp(700).remove();
			form.find('.boardName').removeAttr('style');
			form.find('#shareEmail').removeAttr('style');
		}
	});
	  
	var omniture = function () {
		var logNewBoardCreation = function () {
			var account = s_account ? s_account : "4imprintprod";
			var s = s_gi(account);
			if (typeof s != "undefined") {
	          		s.linkTrackVars = 'prop26';
	          		s.linkTrackEvents = 'None';
	          		s.prop26 = "Fav Board Creations";//New board, log create event
	          		s.tl(true, 'o', 'Fav Board Creations');
	      		}
	    	};
		var viewProductClick = function () {
			var account = s_account ? s_account : "4imprintprod";
			var s = s_gi(account);
			if (typeof s != "undefined") {
		  		s.linkTrackVars = 'eVar36';
		  		s.linkTrackEvents = 'none';
		 		s.eVar36 = "Fav Boards Conversions";//Product click event variable expires at purchase
		  		s.tl(true, 'o', 'Fav Boards Conversions');
			}
	    	};
	    	return {
	      		ViewProductClick: viewProductClick,
	      		LogNewBoardCreation: logNewBoardCreation
	    	}
	};
	  
	//add to idea board
	var AddToIdeaBoard = function (e) {
		var d = $(e).siblings('.board-id').val();
		var productID = (typeof (prodID) == 'undefined') ? $(e).closest('.favPrintIcons').find('input.faveLinkProdID').val() : prodID;
	  
		if (productID == null) {
			//still not found? try mobile details
			productID = $('#productid').val();
		}
	  
		var data = { boardID: d, productID: productID };
		$.ajax({
			url: "/favs/additemtoboard",
	     		type: "POST",
	      		data: JSON.stringify(data),
	      		beforeSend: function (req) {
	        		$(e).siblings('.addItemLoading').fadeIn('fast');
	      		},
	      		complete: function (req) {
	       		$(e).siblings('.addItemLoading').fadeOut('fast');
	      		},
	      		contentType: 'application/json',
	      		dataType: 'json',
	      		success: function (result) {
	        		//If the user is able to place a sample request display the sample request form otherwise let them know when they are not able to.
	        		$(e).after((result.message));
	        		if (result.success == "true") {
	            			$(e).closest('.favPrintIcons').find('.faveLink').removeClass('textDkGray').addClass('textRed');
	        		}
	      		}
	    	});
	};
	  
	function DeleteBoardItem(e, f, g) {
		var boardID = e;
		var boardItemID = f;
		var data = { boardID: boardID, boardItemID: boardItemID };
	  
		$.ajax({
	      		url: '/favs/deleteboarditem',
	      		type: "POST",
	      		data: JSON.stringify(data),
	      		dataType: 'json',
	      		contentType: "application/json",
	      		beforeSend: function () {
	          		$(g).siblings('.addItemLoading').fadeIn('fast');
	      		},
	      		complete: function (result) {
	          		$(g).siblings('.addItemLoading').fadeOut('fast');
	      		},
	      		success: function (result) {
	          		if (result.isItemInOtherBoards == "False") {
	              		$(g).closest('.favPrintIcons').find('.faveLink').removeClass('textRed').addClass('textDkGray');
	          		}
	          		$(g).closest('.addToBoardMsg').slideUp('fast').remove();
	      		},
	      		error: function (result) { }
	    	});
	}
	  
	function GetBoardForm() {
		$.ajax({
	      		url: '/favs/getcartboardform',
	      		type: "POST",
	      		dataType: 'html',
	      		contentType: "application/json",
	      		beforeSend: function () {
	        		$("#loading").removeClass("hide");
	     	 	},
	      		complete: function (result) {
	        		$("#loading").addClass("hide");
	      		},
	     	 	success: function (result) {
	        		$('#mainContent').append(result);
	        		var saveAsFavorite = dialog4i();
	        		saveAsFavorite.init(document.getElementById('newBoardForm'));
	        		saveAsFavorite.open();
	        		$('#BoardName').focus();
	        		$('#newBoardForm').on('keydown', function (e) {
		           		if ((e.which || e.keyCode) === 27) { /*esc*/
		                		$('#newBoardForm').remove();
		                		$('.saveAsFavBoard').focus();
		            		}
		        	});
	        		$('.addItemLoading').removeClass('show').addClass('hide');
	      		},
	      		error: function (result) { }
	    	});
	}
	  
	function CreateBoardWithCart(e) {
		var form = $(e).closest('#newBoardForm');
	    	var boardName = form.find('#BoardName').val();
	    	var isDefaultBoard = form.find('#IsDefaultBoard').is(':checked');
	    	var note = form.find('#Notes').val();
	    	var cartID = $('#UserCart_CartID').val();
	    	var data = { BoardName: boardName, CreatedDate: null, GURID: '', IsDefaultBoard: isDefaultBoard, Notes: note, CartID: cartID };
	  
	    	$.ajax({
	      		url: '/favs/addnewboard',
	      		type: "POST",
	      		data: JSON.stringify(data),
	      		dataType: 'html',
	      		contentType: "application/json",
	      		beforeSend: function () { },
	      		success: function (result) {
	        		var rt = $.parseHTML(result);
	        		if (rt.length > 1) {
	          			omniture().LogNewBoardCreation();
	          			$('#newBoardForm').replaceWith(result);
	          			$('.newBoardMsg').focus();
	        		}
	        		$('.ErrorMsgPanel').remove();
	        		var boardName = form.find('#BoardName');
	        		boardName.css('background-color', 'rgb(255, 217, 217)');
	        		var temp = GetValidationTemplate();
	        		temp = temp.replace('##ERRORLIST##', '<li><a href="#" tabindex="0" role="link"><span>' + result + '</span></a><li/>');
	        		form.find('.existingBoardHdr').after(temp);
	        		form.find('#ErrorMsgBox li:last-child').remove();
	        		boardName.focus();
	      		},
	      		error: function (result) { }
		});
	}
	  
	//add to idea board
	function AddCartItemsToBoard(e) {
	    	var boardID = $(e).siblings('.board-id').val();
	    	var cartID = $('#UserCart_CartID').val();
	    	var data = { cartID: cartID, boardID: boardID };
	  
	    	$.ajax({
	      		url: "/favs/addcartitemstoboard",
	      		type: "POST",
	      		data: JSON.stringify(data),
	      		beforeSend: function (req) {
	        		$(e).siblings('.addItemLoading').fadeIn('fast');
	      		},
	      		complete: function (req) {
	        		$(e).siblings('.addItemLoading').fadeOut('fast');
	      		},
	      		contentType: 'application/json',
	      		dataType: 'json',
	      		success: function (result) {
	        		$(e).after((result.message));
	      		}
	    	});
	}
	  
	function GetValidationTemplate() {
		template =
	      		'<div class="ErrorMsgPanel text15 validation-summary-errors textDkRed clear" id="ErrorBox" role="alert">' +
	      		'<p class="paddingTop10 semibold marginLeft10 validationHeading textDkRed" id="ErrorTitle">Oops! Some of the information you entered is not correct.</p>' +
	      		'<div class="textDkRed" id="ErrorMsgBox">' +
	      		'<ul class="text14">##ERRORLIST##</ul>' +
	      		'</div>' +
	      		'</div>';
	    	return template;
	}
	  
	function ClickOnKeyPress(trig, e) {
		if (e.which == 13) { $(trig).click(); }
	}
});